import { create } from 'zustand';
import type { ParkingSpotAttributes } from '@lotngo/shared';

export interface FreeSpot {
  id: string;
  spot_number: string;
  level_code: string;
  level_label: string;
  description: string | null;
  attributes?: ParkingSpotAttributes;
  owner?: { id: string; apartment: string };
  availability: {
    source: 'schedule' | 'window';
    until: string;
    starts_at?: string;
  };
}

interface SpotState {
  freeSpots: FreeSpot[];
  allLoaded: boolean;
  setFreeSpots: (spots: FreeSpot[]) => void;
  updateSpotStatus: (spotId: string, status: string) => void;
  removeSpot: (spotId: string) => void;
}

export const useSpotStore = create<SpotState>((set) => ({
  freeSpots:  [],
  allLoaded:  false,

  setFreeSpots: (spots) => set({ freeSpots: spots, allLoaded: true }),

  updateSpotStatus: (spotId, status) => set((state) => ({
    freeSpots: state.freeSpots.map((s) =>
      s.id === spotId ? { ...s, status } : s,
    ),
  })),

  removeSpot: (spotId) => set((state) => ({
    freeSpots: state.freeSpots.filter((s) => s.id !== spotId),
  })),
}));
